import { registerView, ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import React from "react";
import { Form } from "react-bootstrap";
import VehicleInfoViewModel from "viewModels/common/vehicleInfoViewModel";
import CountryIdInput from "../countryIdInput/countryIdInput";
import CountryIdWithConfirmation from "../countryIdInput/countryIdInputWithConfirmation";
import LicensePlateInput from "../licensePlateInput/licensePlateInput";
import LicensePlateInputWithConfirmation from "../licensePlateInput/licensePlateInputWithConfirmation";

const VehicleInfoView: ViewComponent<VehicleInfoViewModel> = observer(({ vm }) => {
  const config = vm.config;
  const translate = (translateKey?: string) => (code: string) =>
    vm.localizationService.translateAttribute(translateKey ? `orderItem.${translateKey}` : "orderItem", code);
  return (
    <>
      <Form.Row className="align-items-baseline">
        {config.countryIDConfirmation ? (
          <CountryIdWithConfirmation vm={vm} disabled={vm.isDisabled} context={config.context} />
        ) : (
          <CountryIdInput vm={vm} disabled={vm.isDisabled} translateKey={config.context} breakpoint={config.breakpoint} />
        )}
        {!config.licensePlateConfirmation && (
          <LicensePlateInput
            id="license-plate-input"
            target={vm.item}
            property="licensePlate"
            fixedLength={config.fixedLicensePlateSize}
            countryId={vm.item.countryId}
            countryCode={vm.isDisabled ? undefined : vm.countryCode}
            disabled={vm.isDisabled}
            translate={translate(config.context)}
            locale={vm.localizationService.locale}
            breakpoint={config.breakpoint}
          />
        )}
      </Form.Row>
      {config.licensePlateConfirmation && <LicensePlateInputWithConfirmation vm={vm} context={config.context} />}
    </>
  );
});

registerView(VehicleInfoView, VehicleInfoViewModel);
